export const purple = {"100":"#FFF8FF","150":"#FCEBFC","200":"#EFDFF0","300":"#EBC5EE","400":"#E6ABEB","500":"#E08FE8","600":"#D972E4","700":"#D059DC","800":"#C63BD4","900":"#BC00CC","1000":"#A80CB6","1100":"#9412A0","1200":"#81158A","1300":"#6E1676","1400":"#5B1662","1500":"#4A144E","1600":"#38123C","1700":"#38123B","1800":"#231224","1900":"#1F0D21","2000":"#0D070E"};
export const violet = {"100":"#FAFAFF","150":"#E5E5FF","200":"#E4E2F7","300":"#CEC8FB","400":"#BAAEFE","500":"#A693FF","600":"#9681FD","700":"#876EFA","800":"#785AF7","900":"#6A42F4","1000":"#5E3FD5","1100":"#583CC5","1200":"#513AB6","1300":"#4B37A7","1400":"#453498","1500":"#3D307E","1600":"#352B65","1700":"#2D264D","1800":"#26224D","1900":"#1E193A","2000":"#151029"};
export const plum = {"100":"#EFE9FB","200":"#DCCCF7","300":"#CBAEF4","400":"#BC8FF3","500":"#AE6FF3","600":"#A34DF4","700":"#9B2BF6","800":"#9606F9","900":"#8C01DE","1000":"#7C01C5","1100":"#6B01AB","1200":"#5B0092","1300":"#4B0078","1400":"#3B005F","1500":"#2B0045","1600":"#1B002C"};
export const blue = {"100":"#F4FDFF","150":"#E8F3FF","200":"#DAE7F9","300":"#BCD7FC","400":"#9EC7FE","500":"#7FB6FF","600":"#5FA5FF","700":"#529AFA","800":"#4590F5","900":"#3785F0","1000":"#3A7BD5","1100":"#3571C3","1200":"#3066B1","1300":"#2B5CA0","1400":"#26528F","1500":"#22497E","1600":"#1D3F6E","1700":"#173964","1800":"#102847","1900":"#09192D","2000":"#040A14"};
export const lime = {"100":"#FBFDF2","150":"#F1FFB0","200":"#EAFF84","300":"#E4FC56","400":"#D6EC51","500":"#C8DD4B","600":"#BACD46","700":"#ACBE41","800":"#9EAF3C","900":"#91A137","1000":"#849232","1100":"#77842D","1200":"#6A7628","1300":"#5E6823","1400":"#525B1F","1500":"#464E1A","1600":"#3B4116","1700":"#2F3511","1800":"#25290D","1900":"#1A1E08","2000":"#111305"};
export const orange = {"100":"#FFF8F1","150":"#FFE1CA","200":"#FFCFB0","300":"#FFBE98","400":"#FFAE81","500":"#FF9D6B","600":"#FF8D54","700":"#FF7C3B","800":"#FF6B1A","900":"#EB6114","1000":"#D7570D","1100":"#C44E07","1200":"#B14401","1300":"#9E3B00","1400":"#8C3200","1500":"#7A2900","1600":"#692100","1700":"#581800","1800":"#471000","1900":"#370800","2000":"#280300"};
export const red = {"100":"#FFF7F4","150":"#FFEAE5","200":"#F7D2CD","300":"#F7C7C2","400":"#F5B0A9","500":"#F19890","600":"#ED8078","700":"#F17066","800":"#F45E53","900":"#F6483E","1000":"#E34138","1100":"#CF3B32","1200":"#BD342D","1300":"#AA2E27","1400":"#992824","1500":"#882321","1600":"#771E1E","1700":"#67191A","1800":"#4A0E0F","1900":"#2E0505","2000":"#150101"};
export const green = {"100":"#F8FDF8","150":"#E8FAE7","200":"#D8F3D4","300":"#BFEBBB","400":"#A5E29B","500":"#88D77C","600":"#7BC874","700":"#72BB6A","800":"#69AD62","900":"#60A159","1000":"#579452","1100":"#4F8549","1200":"#467942","1300":"#3E6C3A","1400":"#375E33","1500":"#2F512A","1600":"#284424","1700":"#21391D","1800":"#192D17","1900":"#132113","2000":"#0F160F"};
export const yellow = {"100":"#FFF8D9","150":"#F8EDD4","200":"#EFE3D0","300":"#F8DBA4","400":"#FDD36F","500":"#FFCC00","600":"#F5C36C","700":"#E3B362","800":"#D1A458","900":"#C0954E","1000":"#AF8745","1100":"#9E783C","1200":"#8D6A32","1300":"#7D5C29","1400":"#6D4F21","1500":"#5D4218","1600":"#4D350B","1700":"#3D2900","1800":"#311A09","1900":"#1E1200","2000":"#160402"};
export const grey = {"100":"#FFFFFF","200":"#F1F1F1","300":"#E3E3E3","400":"#D5D5D5","500":"#C7C6C7","600":"#BAB8BA","700":"#ACAAAC","800":"#9F9B9F","900":"#918D91","1000":"#858185","1100":"#797579","1200":"#6D6A6D","1300":"#615E61","1400":"#555355","1500":"#494749","1600":"#3D3C3D"};
export const black = {"100":"#4D4C4C","200":"#494848","300":"#464545","400":"#424141","500":"#3E3D3D","600":"#3A3939","700":"#373636","800":"#333232","900":"#2F2E2E","1000":"#2B2A2A","1100":"#282727","1200":"#242323","1300":"#201F1F","1400":"#1C1B1B","1500":"#191818","1600":"#151414","1700":"#111010","1800":"#0D0C0C","1900":"#0A0909","2000":"#060505"};
export const navy = {"100":"#F1F1F4","200":"#DADAE3","300":"#C4C3D3","400":"#ACABC4","500":"#9592B5","600":"#7E78A7","700":"#675F98","800":"#574E82","900":"#463E6B","1000":"#362E53","1100":"#302652","1200":"#2B1F51","1300":"#25194F","1400":"#21134D","1500":"#1C0E49","1600":"#180A46"};
export const white_alpha = {"5":"#FFFFFF0D","10":"#FFFFFF1A","15":"#FFFFFF26","20":"#FFFFFF33","25":"#FFFFFF40","30":"#FFFFFF4D","35":"#FFFFFF59","40":"#FFFFFF66","45":"#FFFFFF73","50":"#FFFFFF80","55":"#FFFFFF8C","60":"#FFFFFF99","65":"#FFFFFFA6","70":"#FFFFFFB3"};
export const black_alpha = {"2":"#00000005","4":"#0000000A","6":"#0000000F","8":"#00000014","10":"#0000001A","12":"#0000001F","14":"#00000024","16":"#00000029","18":"#0000002E","20":"#00000033","22":"#00000038","24":"#0000003D","26":"#00000042","28":"#00000047","30":"#0000004D","32":"#00000052","34":"#00000057"};
export const navy_alpha = {"1":"#30265203","2":"#30265205","4":"#3026520A","6":"#3026520F","8":"#30265214","10":"#3026521A","14":"#30265224","16":"#30265229","20":"#30265233","24":"#3026523D","26":"#30265242","30":"#3026524D","40":"#30265266","50":"#30265280","60":"#30265299","70":"#302652B3","80":"#302652CC","90":"#302652E6","98":"#302652FA"};
export const grey_alpha = {"1":"#E3E3E303","2":"#E3E3E305","4":"#E3E3E30A","6":"#E3E3E30F","8":"#E3E3E314","10":"#E3E3E31A","15":"#E3E3E326","20":"#E3E3E333","25":"#E3E3E340","30":"#E3E3E34D","35":"#E3E3E359","40":"#E3E3E366","45":"#E3E3E373","50":"#E3E3E380","60":"#E3E3E399","70":"#E3E3E3B3","80":"#E3E3E3CC","90":"#E3E3E3E6","95":"#E3E3E3F2"};
export const white = "#FFFFFF";
export default {
  "purple": {
    "100": "#FFF8FF",
    "150": "#FCEBFC",
    "200": "#EFDFF0",
    "300": "#EBC5EE",
    "400": "#E6ABEB",
    "500": "#E08FE8",
    "600": "#D972E4",
    "700": "#D059DC",
    "800": "#C63BD4",
    "900": "#BC00CC",
    "1000": "#A80CB6",
    "1100": "#9412A0",
    "1200": "#81158A",
    "1300": "#6E1676",
    "1400": "#5B1662",
    "1500": "#4A144E",
    "1600": "#38123C",
    "1700": "#38123B",
    "1800": "#231224",
    "1900": "#1F0D21",
    "2000": "#0D070E"
  },
  "violet": {
    "100": "#FAFAFF",
    "150": "#E5E5FF",
    "200": "#E4E2F7",
    "300": "#CEC8FB",
    "400": "#BAAEFE",
    "500": "#A693FF",
    "600": "#9681FD",
    "700": "#876EFA",
    "800": "#785AF7",
    "900": "#6A42F4",
    "1000": "#5E3FD5",
    "1100": "#583CC5",
    "1200": "#513AB6",
    "1300": "#4B37A7",
    "1400": "#453498",
    "1500": "#3D307E",
    "1600": "#352B65",
    "1700": "#2D264D",
    "1800": "#26224D",
    "1900": "#1E193A",
    "2000": "#151029"
  },
  "plum": {
    "100": "#EFE9FB",
    "200": "#DCCCF7",
    "300": "#CBAEF4",
    "400": "#BC8FF3",
    "500": "#AE6FF3",
    "600": "#A34DF4",
    "700": "#9B2BF6",
    "800": "#9606F9",
    "900": "#8C01DE",
    "1000": "#7C01C5",
    "1100": "#6B01AB",
    "1200": "#5B0092",
    "1300": "#4B0078",
    "1400": "#3B005F",
    "1500": "#2B0045",
    "1600": "#1B002C"
  },
  "blue": {
    "100": "#F4FDFF",
    "150": "#E8F3FF",
    "200": "#DAE7F9",
    "300": "#BCD7FC",
    "400": "#9EC7FE",
    "500": "#7FB6FF",
    "600": "#5FA5FF",
    "700": "#529AFA",
    "800": "#4590F5",
    "900": "#3785F0",
    "1000": "#3A7BD5",
    "1100": "#3571C3",
    "1200": "#3066B1",
    "1300": "#2B5CA0",
    "1400": "#26528F",
    "1500": "#22497E",
    "1600": "#1D3F6E",
    "1700": "#173964",
    "1800": "#102847",
    "1900": "#09192D",
    "2000": "#040A14"
  },
  "lime": {
    "100": "#FBFDF2",
    "150": "#F1FFB0",
    "200": "#EAFF84",
    "300": "#E4FC56",
    "400": "#D6EC51",
    "500": "#C8DD4B",
    "600": "#BACD46",
    "700": "#ACBE41",
    "800": "#9EAF3C",
    "900": "#91A137",
    "1000": "#849232",
    "1100": "#77842D",
    "1200": "#6A7628",
    "1300": "#5E6823",
    "1400": "#525B1F",
    "1500": "#464E1A",
    "1600": "#3B4116",
    "1700": "#2F3511",
    "1800": "#25290D",
    "1900": "#1A1E08",
    "2000": "#111305"
  },
  "orange": {
    "100": "#FFF8F1",
    "150": "#FFE1CA",
    "200": "#FFCFB0",
    "300": "#FFBE98",
    "400": "#FFAE81",
    "500": "#FF9D6B",
    "600": "#FF8D54",
    "700": "#FF7C3B",
    "800": "#FF6B1A",
    "900": "#EB6114",
    "1000": "#D7570D",
    "1100": "#C44E07",
    "1200": "#B14401",
    "1300": "#9E3B00",
    "1400": "#8C3200",
    "1500": "#7A2900",
    "1600": "#692100",
    "1700": "#581800",
    "1800": "#471000",
    "1900": "#370800",
    "2000": "#280300"
  },
  "red": {
    "100": "#FFF7F4",
    "150": "#FFEAE5",
    "200": "#F7D2CD",
    "300": "#F7C7C2",
    "400": "#F5B0A9",
    "500": "#F19890",
    "600": "#ED8078",
    "700": "#F17066",
    "800": "#F45E53",
    "900": "#F6483E",
    "1000": "#E34138",
    "1100": "#CF3B32",
    "1200": "#BD342D",
    "1300": "#AA2E27",
    "1400": "#992824",
    "1500": "#882321",
    "1600": "#771E1E",
    "1700": "#67191A",
    "1800": "#4A0E0F",
    "1900": "#2E0505",
    "2000": "#150101"
  },
  "green": {
    "100": "#F8FDF8",
    "150": "#E8FAE7",
    "200": "#D8F3D4",
    "300": "#BFEBBB",
    "400": "#A5E29B",
    "500": "#88D77C",
    "600": "#7BC874",
    "700": "#72BB6A",
    "800": "#69AD62",
    "900": "#60A159",
    "1000": "#579452",
    "1100": "#4F8549",
    "1200": "#467942",
    "1300": "#3E6C3A",
    "1400": "#375E33",
    "1500": "#2F512A",
    "1600": "#284424",
    "1700": "#21391D",
    "1800": "#192D17",
    "1900": "#132113",
    "2000": "#0F160F"
  },
  "yellow": {
    "100": "#FFF8D9",
    "150": "#F8EDD4",
    "200": "#EFE3D0",
    "300": "#F8DBA4",
    "400": "#FDD36F",
    "500": "#FFCC00",
    "600": "#F5C36C",
    "700": "#E3B362",
    "800": "#D1A458",
    "900": "#C0954E",
    "1000": "#AF8745",
    "1100": "#9E783C",
    "1200": "#8D6A32",
    "1300": "#7D5C29",
    "1400": "#6D4F21",
    "1500": "#5D4218",
    "1600": "#4D350B",
    "1700": "#3D2900",
    "1800": "#311A09",
    "1900": "#1E1200",
    "2000": "#160402"
  },
  "grey": {
    "100": "#FFFFFF",
    "200": "#F1F1F1",
    "300": "#E3E3E3",
    "400": "#D5D5D5",
    "500": "#C7C6C7",
    "600": "#BAB8BA",
    "700": "#ACAAAC",
    "800": "#9F9B9F",
    "900": "#918D91",
    "1000": "#858185",
    "1100": "#797579",
    "1200": "#6D6A6D",
    "1300": "#615E61",
    "1400": "#555355",
    "1500": "#494749",
    "1600": "#3D3C3D"
  },
  "black": {
    "100": "#4D4C4C",
    "200": "#494848",
    "300": "#464545",
    "400": "#424141",
    "500": "#3E3D3D",
    "600": "#3A3939",
    "700": "#373636",
    "800": "#333232",
    "900": "#2F2E2E",
    "1000": "#2B2A2A",
    "1100": "#282727",
    "1200": "#242323",
    "1300": "#201F1F",
    "1400": "#1C1B1B",
    "1500": "#191818",
    "1600": "#151414",
    "1700": "#111010",
    "1800": "#0D0C0C",
    "1900": "#0A0909",
    "2000": "#060505"
  },
  "navy": {
    "100": "#F1F1F4",
    "200": "#DADAE3",
    "300": "#C4C3D3",
    "400": "#ACABC4",
    "500": "#9592B5",
    "600": "#7E78A7",
    "700": "#675F98",
    "800": "#574E82",
    "900": "#463E6B",
    "1000": "#362E53",
    "1100": "#302652",
    "1200": "#2B1F51",
    "1300": "#25194F",
    "1400": "#21134D",
    "1500": "#1C0E49",
    "1600": "#180A46"
  },
  "white_alpha": {
    "5": "#FFFFFF0D",
    "10": "#FFFFFF1A",
    "15": "#FFFFFF26",
    "20": "#FFFFFF33",
    "25": "#FFFFFF40",
    "30": "#FFFFFF4D",
    "35": "#FFFFFF59",
    "40": "#FFFFFF66",
    "45": "#FFFFFF73",
    "50": "#FFFFFF80",
    "55": "#FFFFFF8C",
    "60": "#FFFFFF99",
    "65": "#FFFFFFA6",
    "70": "#FFFFFFB3"
  },
  "black_alpha": {
    "2": "#00000005",
    "4": "#0000000A",
    "6": "#0000000F",
    "8": "#00000014",
    "10": "#0000001A",
    "12": "#0000001F",
    "14": "#00000024",
    "16": "#00000029",
    "18": "#0000002E",
    "20": "#00000033",
    "22": "#00000038",
    "24": "#0000003D",
    "26": "#00000042",
    "28": "#00000047",
    "30": "#0000004D",
    "32": "#00000052",
    "34": "#00000057"
  },
  "navy_alpha": {
    "1": "#30265203",
    "2": "#30265205",
    "4": "#3026520A",
    "6": "#3026520F",
    "8": "#30265214",
    "10": "#3026521A",
    "14": "#30265224",
    "16": "#30265229",
    "20": "#30265233",
    "24": "#3026523D",
    "26": "#30265242",
    "30": "#3026524D",
    "40": "#30265266",
    "50": "#30265280",
    "60": "#30265299",
    "70": "#302652B3",
    "80": "#302652CC",
    "90": "#302652E6",
    "98": "#302652FA"
  },
  "grey_alpha": {
    "1": "#E3E3E303",
    "2": "#E3E3E305",
    "4": "#E3E3E30A",
    "6": "#E3E3E30F",
    "8": "#E3E3E314",
    "10": "#E3E3E31A",
    "15": "#E3E3E326",
    "20": "#E3E3E333",
    "25": "#E3E3E340",
    "30": "#E3E3E34D",
    "35": "#E3E3E359",
    "40": "#E3E3E366",
    "45": "#E3E3E373",
    "50": "#E3E3E380",
    "60": "#E3E3E399",
    "70": "#E3E3E3B3",
    "80": "#E3E3E3CC",
    "90": "#E3E3E3E6",
    "95": "#E3E3E3F2"
  },
  "white": "#FFFFFF"
}
;